import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7882 15.8677L15.5522 15.4073L15.2709 15.5516V15.8677H15.7882ZM8.21195 15.8668H8.72931V15.5507L8.44809 15.4065L8.21195 15.8668ZM19.4817 9.16076C19.4817 11.8499 17.9021 14.2026 15.5522 15.4073L16.0243 16.3281C18.6882 14.9624 20.5164 12.2721 20.5164 9.16076H19.4817ZM12.001 2.06526C16.1568 2.06526 19.4817 5.26579 19.4817 9.16076H20.5164C20.5164 4.6468 16.6795 1.03054 12.001 1.03054V2.06526ZM4.52029 9.16076C4.52029 5.26579 7.84515 2.06526 12.001 2.06526V1.03054C7.32241 1.03054 3.48557 4.6468 3.48557 9.16076H4.52029ZM8.44809 15.4065C6.0991 14.2015 4.52029 11.8493 4.52029 9.16076H3.48557C3.48557 12.2714 5.31289 14.9611 7.97581 16.3271L8.44809 15.4065ZM8.72931 19.5276V15.8668H7.69459V19.5276H8.72931ZM9.24667 20.0449C8.96094 20.0449 8.72931 19.8133 8.72931 19.5276H7.69459C7.69459 20.3847 8.38948 21.0796 9.24667 21.0796V20.0449ZM14.7535 20.0449H9.24667V21.0796H14.7535V20.0449ZM15.2709 19.5276C15.2709 19.8133 15.0392 20.0449 14.7535 20.0449V21.0796C15.6107 21.0796 16.3056 20.3847 16.3056 19.5276H15.2709ZM15.2709 15.8677V19.5276H16.3056V15.8677H15.2709Z"
          fill={color}
        />
        <path
          d="M9.62313 10.2835C9.40575 10.098 9.0792 10.1239 8.89376 10.3413C8.70832 10.5586 8.7342 10.8852 8.95158 11.0706L9.62313 10.2835ZM15.0708 11.0707C15.2882 10.8853 15.3141 10.5587 15.1287 10.3413C14.9432 10.1239 14.6167 10.098 14.3993 10.2834L15.0708 11.0707ZM8.95158 11.0706L11.6751 13.3941L12.3467 12.6069L9.62313 10.2835L8.95158 11.0706ZM12.3466 13.3941L15.0708 11.0707L14.3993 10.2834L11.6752 12.6069L12.3466 13.3941ZM11.4935 13.0005V14.3468H12.5283V13.0005H11.4935ZM11.4935 14.3468V15.6931H12.5283V14.3468H11.4935Z"
          fill={color}
        />
        <path d="M8.12361 15.9055H15.9034" stroke={color} strokeWidth="1.03472" />
        <path d="M8.12341 18.1902H15.904" stroke={color} strokeWidth="1.03472" />
        <path
          d="M12.9652 21.369C12.7816 21.7061 12.4241 21.9348 12.0133 21.9348C11.6024 21.9348 11.245 21.7061 11.0614 21.369H12.9652Z"
          fill="#262626"
          stroke={color}
          strokeWidth="1.03472"
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'insight');
export default IconComponent;
